(function () {
  // Brand page header: (1) the logo is cropped to its own artwork and scaled to fill its card, (2) the description is clamped to 4 lines
  // with a Read more / Read less toggle.

  // ---- logo. The uploaded files are 800x800 squares with the artwork in the middle and lots of empty margin, so "contain" leaves the
  // logo tiny. We find the artwork's bounding box (non-transparent, non-white pixels) on a small canvas and scale/position the image so
  // that box fills the card minus a 14px padding. Never distorted. If the canvas cannot be read, the CSS "contain" fallback stays.
  var panel = document.querySelector('[data-brand-logo]');
  var img = panel && panel.querySelector('img');
  var PAD = 14;
  function bbox(im) {
    var N = 240, w = N, h = Math.max(1, Math.round(N * im.naturalHeight / im.naturalWidth));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(im, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
      var i = (yy * w + xx) * 4;
      if (d[i + 3] > 25 && (d[i] + d[i + 1] + d[i + 2]) / 3 < 235) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
    }
    if (x1 < 0) return null;
    return { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h };
  }
  function fit(box) {
    var W = panel.clientWidth - 2 * PAD, H = panel.clientHeight - 2 * PAD;
    var nw = img.naturalWidth, nh = img.naturalHeight;
    var bw = (box.x1 - box.x0) * nw, bh = (box.y1 - box.y0) * nh;
    var s = Math.min(W / bw, H / bh);
    img.style.cssText = 'position:absolute;max-width:none;object-fit:fill;width:' + (nw * s) + 'px;height:' + (nh * s) + 'px;left:' +
      (PAD + (W - bw * s) / 2 - box.x0 * nw * s) + 'px;top:' + (PAD + (H - bh * s) / 2 - box.y0 * nh * s) + 'px;';
  }
  function setup() {
    var box;
    try {
      var probe = new Image(); probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try { box = bbox(probe); } catch (e) { box = null; }
        if (!box) return;
        fit(box);
        if (window.ResizeObserver) new ResizeObserver(function () { fit(box); }).observe(panel); else window.addEventListener('resize', function () { fit(box); });
      };
      probe.src = img.currentSrc || img.src;
    } catch (e) {}
  }
  if (img) { if (img.complete && img.naturalWidth) setup(); else img.addEventListener('load', setup); }

  // ---- description: 4 lines, Read more
  var desc = document.querySelector('[data-brand-desc]');
  var more = document.querySelector('[data-brand-more]');
  if (desc && more) {
    function measure() {
      if (desc.classList.contains('is-open')) { more.hidden = false; return; }
      more.hidden = !(desc.scrollHeight > desc.clientHeight + 2);
    }
    more.addEventListener('click', function () {
      var open = !desc.classList.contains('is-open');
      desc.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? more.getAttribute('data-less') : more.getAttribute('data-more');
    });
    measure(); window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }
})();
